import { useEffect } from "react";
import { View, StyleSheet } from "react-native";
import { useAppConfig } from "../AppConfigProvider";
import { useNavigation } from "@react-navigation/native";
import BlankLayout from "../layouts/BlankLayout";
import CustomText from "../components/common/general/CustomText/CustomText";
import CustomButton from "../components/common/general/CustomButton/CustomButton";
import Logo from "../components/general/logos/Logo";
import CustomSpacing from "../components/common/layout/CustomSpacing/CustomSpacing";
import { usePostHog } from "posthog-js/react";
import { useAuth } from "../hooks/useAuth";

function ThankYouView() {
  const appConfig = useAppConfig();
  const navigate = useNavigation();
  const posthog = usePostHog();
  const { meData, loadingMe } = useAuth();

  const companionName = appConfig.companionName;
  const logo = appConfig.logo;

  const handleContinuePress = () => {
    navigate.navigate("Home");
  };

  useEffect(() => {
    if (!loadingMe) {
      posthog?.capture("Subscription Completed", {
        $set: {
          isPayingUser: true,
          hasFreeTrial: !!meData?.me?.trialEndDate || false,
        },
      });
    }
  }, [loadingMe]);

  return (
    <BlankLayout>
      <View style={styles.container}>
        <Logo uri={logo} />
        <CustomText
          text="purchase_thank_you"
          size="l"
          style={styles.text}
          role="header"
          interpolation={{ companionName }} // Pass companionName here
        />
        <CustomSpacing type="vertical" size="l" />
        <CustomButton text="Continue" onPress={handleContinuePress} size="l" styleType="primary" />
      </View>
    </BlankLayout>
  );
}

const styles = StyleSheet.create({
  container: {
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
  },
  text: {
    textAlign: "center",
  },
});

export default ThankYouView;
